import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';
import state from './state';

export const serviceComputed = {
	...mapState('uploadFormStore', Object.keys(state)),
	...mapGetters('uploadFormStore', Object.keys(getters))
};

export const serviceMethods = {
	...mapActions('uploadFormStore', Object.keys(actions)),
	...mapMutations('uploadFormStore', Object.keys(mutations))
};
